import axiosInstance from "../instance/axiosInstance";

class ProfileApi {
  static async savePersonalInfo(formData) {
    try {
      const response = await axiosInstance.post(
        `/save/personal-information`,
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async saveFalInfo(formData) {
    try {
      const response = await axiosInstance.post(
        `/save/fal-information`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async saveContactDetail(formData) {
    try {
      const response = await axiosInstance.post(
        `/save/contact-detail`,
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async saveSocialMedia(formData) {
    try {
      const response = await axiosInstance.post(`/save/social-media`, formData);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async updateProfileOrCover(formData) {
    try {
      const response = await axiosInstance.post(
        `/update-profile-cover`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async fetchInquiryList(page) {
    try {
      const response = await axiosInstance.get(`/inquires/list?page=${page}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async fetchInquiryDetails(id) {
    try {
      const response = await axiosInstance.get(`/inquires/view/${id}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
}

export default ProfileApi;
